import * as SagaType from '../../constants/constant_saga_types';
import * as ActionType from '../../constants/constant_action_types';

const INITIAL_STATE = {
  fields: [],
  filters: [],
  context: null,
  isFetching: false,
  isFetchingField: false,
  fieldError: {
    isError: false,
    message: '',
  },
  error: {
    isError: false,
    message: '',
  },
};

const addRecordField = (fields, field) => {
  const findIndex = fields.findIndex(({ value }) => value === field.value);

  if (findIndex < 0) {
    return [...fields, field];
  }

  return fields;
};

export default function recordFieldsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SagaType.FETCHING_RECORD_FIELDS: {
      return {
        ...INITIAL_STATE,
        isFetching: true,
      };
    }

    case SagaType.DONE_FETCH_RECORD_FIELDS: {
      return {
        ...INITIAL_STATE,
        ...action.payload,
      };
    }

    case SagaType.FETCHING_RECORD_FIELD: {
      return {
        ...state,
        isFetchingField: true,
        fieldError: { ...INITIAL_STATE.fieldError },
      };
    }

    case ActionType.ADD_RECORD_FIELD: {
      return {
        ...state,
        fields: addRecordField(state.fields, action.payload),
      };
    }

    case SagaType.DONE_FETCH_RECORD_FIELD: {
      return {
        ...state,
        fields: [...state.fields, action.payload],
        isFetchingField: false,
      };
    }

    case SagaType.ERROR_FETCH_RECORD_FIELD: {
      return {
        ...state,
        isFetchingField: false,
        error: {
          isError: true,
          message: action.payload,
        },
      };
    }

    default:
      return state;
  }
}
